export type UserGroupOption = Readonly<{
    id: number
    name: string
}>

export type DepartmentOption = Readonly<{
    id: number
    number: string
    name: string
}>

export type CustomerOption = Readonly<{
    id: number
    name: string
    isOfficeHotel: boolean
    userGroups?: UserGroupOption[]
}>

export type CompanySelectOption =
    | Readonly<{
          type: "customer"
          group: string
          id: number
          name: string
      }>
    | Readonly<{
          type: "tenant"
          group: string
          id: number
          customerId: number
          name: string
      }>

export type UserOption = Readonly<{
    id: number
    initials: string
    employeeId: string
    username: string
    displayName: string
    surname: string
    givenName: string
    email: string
    phoneNumber: string
    mobileNumber: string
    isPrivateAccount: boolean
    department?: DepartmentOption
    userGroup?: UserGroupOption
    language: string
    isActive: boolean
}>

export enum ManageBookingsAction {
    CHANGE_ORGANIZER = "CHANGE_ORGANIZER",
    CANCEL_MEETING = "CANCEL_MEETING",
}

export type ManageBookingsFormValues = Readonly<{
    company: CompanySelectOption | null
    user: UserOption | null
    action: ManageBookingsAction | ""
    updateResourceBooking: boolean
    updateMeetingService: boolean
    newBookingOwner: UserOption | null
}>

type OrganizerType = "RESPONSIBLE" | "CREATOR"

type Organizer = Readonly<{
    type: OrganizerType
    id: number
}>

type ChangeOrganizerOperation = Readonly<{
    type: ManageBookingsAction.CHANGE_ORGANIZER
    dryRun?: boolean
    oldOrganizer: Organizer
    newOrganizer: Organizer
    updateResourceBooking: boolean
    updateMeetingService: boolean
}>

type CancelMeetingOperation = Readonly<{
    type: ManageBookingsAction.CANCEL_MEETING
    dryRun?: boolean
    oldOrganizer: Organizer
    updateResourceBooking: boolean
    updateMeetingService: boolean
}>

export type ManageBookingsOrderOperation = ChangeOrganizerOperation | CancelMeetingOperation

export type ManageBookingsRequest = Readonly<{
    serviceCenterId: number
    orderOperation: ManageBookingsOrderOperation
}>

export type ManageBookingsExcludedOrder = Readonly<{
    count: number
    reason: string
}>

export type ManageBookingsDryRunResponse = Readonly<{
    dryRun: Readonly<{
        affectedOrders: number
        excludedOrders: ManageBookingsExcludedOrder[]
    }>
}>
